var globalIsUsingStaticRendering = false;
export function enableStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
export function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}
//# sourceMappingURL=staticRendering.js.map